export const APP_NAME = 'FIA Weather Portal';

// Bootstrap API Configuration (must stay in env - needed before auth)
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';
export const TIO_API_BASE_URL = import.meta.env.VITE_TIO_API_BASE_URL || 'https://api.tomorrow.io/v4';

// Mapbox Configuration
export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN || '';

// Datadog RUM Configuration (read directly from env - needed before auth)
export const DATADOG_ENABLED = import.meta.env.VITE_DATADOG_ENABLED === 'true';
export const DATADOG_APPLICATION_ID = import.meta.env.VITE_DATADOG_APPLICATION_ID || '';
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN || '';
export const DATADOG_SITE = import.meta.env.VITE_DATADOG_SITE || 'datadoghq.com';
export const DATADOG_SERVICE = import.meta.env.VITE_DATADOG_SERVICE || 'fia-weather-portal';
export const DATADOG_ENV = import.meta.env.VITE_DATADOG_ENV || 'development';
export const DATADOG_VERSION = import.meta.env.VITE_DATADOG_VERSION || '1.0.0';

// Note: Other configs use clientConfigService (supports ENV override for local dev):
// - recaptcha.*   → getRecaptchaConfig()
// - sse.*         → getSSEServiceUrl()

export const ROUTES = {
  LOGIN: '/login',
  CLIMATE_RECAP: '/climate-recap',
  FORECAST: '/forecast',
  NOWCASTING: '/nowcasting',
  OBSERVATIONS: '/observations',
  MESSAGES: '/messages',
  ALERTS: '/alerts',
  RAIN_FORECASTS: '/rain-forecasts',
  FORECAST_FIELDS: '/forecast-fields',
  OBSERVATION_FIELDS: '/observation-fields',
  CIRCUITS_CLIMATE: '/circuits/climate',
  CIRCUITS: '/circuits',
  TEAMS: '/teams',
  EVENTS: '/events',
  JOBS: '/jobs',
  FORECAST_MANAGEMENT: '/forecast-management',
  FEEDBACK: '/feedback',
  FEEDBACK_TEAM: '/feedback/team',
  FEEDBACK_MANAGEMENT: '/feedback-management',
  SYSTEM_CONFIG: '/system-config',
  API_DOCS: '/api-docs',
  PORTAL_DOCS: '/portal-docs',
  ADMIN_DOCS: '/admin-docs',
  TIMELINES_API: '/timelines-api',
  RADAR_STATUS: '/radar/status',
  STATIONS_STATUS: '/stations/status',
  STATION_INGEST: '/stations/ingest',
  RADAR_L2_INGEST: '/radar/l2-processing',
  USER_MANAGEMENT: '/user-management',
  DASHBOARDS: '/dashboards',
} as const;

export const MENU_ITEMS = [
  { key: 'climate-recap', label: 'Climate Recap', path: ROUTES.CLIMATE_RECAP },
  { key: 'forecast', label: 'Forecast', path: ROUTES.FORECAST },
  { key: 'nowcasting', label: 'Nowcasting', path: ROUTES.NOWCASTING },
  { key: 'observations', label: 'Observations', path: ROUTES.OBSERVATIONS },
  { key: 'messages', label: 'Messages', path: ROUTES.MESSAGES },
  { key: 'alerts', label: 'Alerts', path: ROUTES.ALERTS },
  { key: 'rain-forecasts', label: 'Rain Forecasts', path: ROUTES.RAIN_FORECASTS },
  { key: 'forecast-fields', label: 'Forecast Fields', path: ROUTES.FORECAST_FIELDS, rootOnly: true },
  { key: 'observation-fields', label: 'Observation Fields', path: ROUTES.OBSERVATION_FIELDS, rootOnly: true },
  { key: 'circuits-climate', label: 'Circuits', path: ROUTES.CIRCUITS_CLIMATE },
  { key: 'circuits', label: 'Circuits', path: ROUTES.CIRCUITS, rootOnly: true },
  { key: 'teams', label: 'Teams', path: ROUTES.TEAMS, rootOnly: true },
  { key: 'system-config', label: 'System Config', path: ROUTES.SYSTEM_CONFIG, rootOnly: true },
  { key: 'jobs', label: 'Jobs', path: ROUTES.JOBS, rootOnly: true },
  { key: 'events', label: 'Events', path: ROUTES.EVENTS },
  { key: 'api-docs', label: 'API Documentation', path: ROUTES.API_DOCS },
  { key: 'timelines-api', label: 'Timelines API', path: ROUTES.TIMELINES_API, rootOnly: true },
] as const;

